import React from 'react';
import { navigate } from 'gatsby';
import { Marker } from 'react-leaflet';
import * as routes from '../../routes';
import { JobType } from './MapWrapper';
import { Icon, IconOptions } from 'leaflet';

const MapMarkerWrapper = (props: { icon: Icon<IconOptions>; job: JobType }) => {
  const { icon, job } = props;

  const lat = Number(job.lat);
  const lng = Number(job.lng);

  function onMarkerClick() {
    const jobId =
      'jobKey' in job
        ? job.jobKey
        : 'jobId' in job
          ? job.jobId
          : 'id' in job
            ? job.id
            : null;

    if (jobId) {
      navigate(routes.toJobSearchJobDetail(jobId));
    }
  }

  return (
    <Marker
      position={[lat, lng]}
      icon={icon}
      eventHandlers={{ click: onMarkerClick }}
    />
  );
};

export default MapMarkerWrapper;
